import { useTranslation } from 'react-i18next'

/** Keep authored phrases together when they fit, without forcing a new line. */
export function HeadingPhrases({ text }: { readonly text: string }) {
  const { i18n } = useTranslation()
  const separator = i18n.resolvedLanguage === 'zh-TW' ? '' : ' '

  return text.split('\n').map((phrase, index) => (
    <span key={index}>
      {index > 0 ? separator : null}
      <span className="lp-heading-phrase">{phrase}</span>
    </span>
  ))
}
